
import { defineComponent } from 'vue';

export enum ButtonType {
  Primary,
  Neutral,
}

export default defineComponent({
  name: 'Button',
  props: {
    iconLeft: String,
    iconRight: String,
    type: {
      default: ButtonType.Primary,
      validator: (type: string) => ButtonType[type] !== undefined,
    },
    color: String,
    // Removes text on mobile, leaving only the icon(s)
    mobileCollapse: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    leftClasses(): string {
      if (!this.iconLeft) return '';
      return `fa-${this.iconLeft}`;
    },
    rightClasses(): string {
      if (!this.iconRight) return '';
      return `fa-${this.iconRight}`;
    },
    buttonClass(): string {
      switch (this.type) {
        case ButtonType.Neutral:
          return 'neutral';
        case ButtonType.Primary:
          return 'primary';
        default:
          return 'primary';
      }
    },
  },
});
